import React from 'react';
import './css/Main.css';

export default function MainBenefits() {
  return (
    <>
      <section className="benefit-section">
        <h2 className="section-title">WHY CHOOSE P2PAUTO?</h2>
        <div className="cards">
          <div className="card">
            <h3>💰 Higher Selling Price</h3>
            <p>Sell directly to consumers and maximize your vehicle value.</p>
          </div>
          <div className="card">
            <h3>🚗 Better Buying Value</h3>
            <p>Buy quality cars without unnecessary dealer markups.</p>
          </div>
          <div className="card">
            <h3>🛡 Safe & Transparent</h3>
            <p>Inspection, documentation and ownership transfer handled professionally.</p>
          </div>
        </div>
      </section>
      <section className="benefit-section-mobile">
        <h2 className="section-title">WHY CHOOSE P2PAUTO?</h2>
        <div className="card-mobile benefit"><div className="icon">💰</div><div><b>Higher Selling Price</b><br/>Sell directly to real buyers.</div></div>
        <div className="card-mobile benefit"><div className="icon">🚗</div><div><b>Better Buying Value</b><br/>No unnecessary dealer markup.</div></div>
        <div className="card-mobile benefit"><div className="icon">🛡️</div><div><b>Professional Protection</b><br/>Inspection, paperwork and ownership transfer handled for you.</div></div>
      </section>
    </>
  )
}
